import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed" }
const _hoisted_2 = { class: "card mb-10" }
const _hoisted_3 = { class: "card-body d-flex align-items-center py-8" }
const _hoisted_4 = { class: "d-flex h-80px w-80px flex-shrink-0 flex-center position-relative" }
const _hoisted_5 = { class: "svg-icon svg-icon-primary position-absolute opacity-15" }
const _hoisted_6 = { class: "svg-icon svg-icon-3x svg-icon-primary position-absolute" }
const _hoisted_7 = { class: "ms-6" }
const _hoisted_8 = { class: "list-unstyled text-gray-600 fw-bold fs-6 p-0 m-0" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Actualmente no cuenta con servicios contratados en la nube. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_ServicesTable = _resolveComponent("ServicesTable")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, {
              src: "media/icons/duotone/Layout/Layout-polygon.svg",
              class: "h-80px w-80px"
            })
          ]),
          _createVNode("span", _hoisted_6, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Tools/Tools.svg" })
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("p", _hoisted_8, [
            (_ctx.list.length === 0)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _hoisted_9
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.list.length > 0)
              ? (_openBlock(), _createBlock(_component_ServicesTable, {
                  key: 1,
                  list: _ctx.list,
                  "widget-classes": "mb-5 mb-xl-8"
                }, null, 8, ["list"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}